import { memo } from 'react'
import { moveInOrder } from './collectionOrder.js'

/**
 * Flèches de réordonnancement d'une taxonomie (genres, formats).
 *
 * Les trois écrans proposaient « Ordre de tri manuel » sans aucun moyen de le
 * poser : l'ordre existait en base, se relisait à l'affichage, mais restait
 * celui de la création. Ces flèches ferment l'écart, avec la même mécanique que
 * les collections — échange d'un cran, permutation exacte envoyée à l'API.
 */

interface TaxonomyReorderButtonsProps {
  /** Ordre complet actuel, celui qui sera permuté. */
  orderedIds: string[]
  id:         string
  label:      string
  /**
   * Faux pendant une recherche ou un tri alphabétique : déplacer une ligne
   * au-dessus d'un voisin invisible, ou dans un ordre qui n'est pas celui
   * qu'on enregistre, poserait un classement que l'opérateur n'a pas voulu.
   */
  enabled:    boolean
  /** Motif affiché quand le geste est indisponible. */
  disabledReason?: string
  onReorder:  (orderedIds: string[]) => void
}

export const TaxonomyReorderButtons = memo(function TaxonomyReorderButtons({
  orderedIds, id, label, enabled, disabledReason, onReorder,
}: TaxonomyReorderButtonsProps) {
  const index = orderedIds.indexOf(id)
  const isFirst = index <= 0
  const isLast  = index < 0 || index >= orderedIds.length - 1

  const move = (direction: -1 | 1) => {
    const next = moveInOrder(orderedIds, id, direction)
    if (next) onReorder(next)
  }

  return (
    <>
      <button
        type="button"
        className="catalog-icon-action"
        disabled={!enabled || isFirst}
        onClick={() => move(-1)}
        aria-label={`Monter ${label}`}
        title={enabled ? 'Monter' : disabledReason ?? 'Réordonnancement indisponible'}
      >
        ↑
      </button>
      <button
        type="button"
        className="catalog-icon-action"
        disabled={!enabled || isLast}
        onClick={() => move(1)}
        aria-label={`Descendre ${label}`}
        title={enabled ? 'Descendre' : disabledReason ?? 'Réordonnancement indisponible'}
      >
        ↓
      </button>
    </>
  )
})
